var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"sag-button",class:_vm.addClass},[_c('b-button',_vm._g(_vm._b({},'b-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('div',[_vm._v(" "+_vm._s(_vm.label)+" ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }